export const IS_PREVIEW = process.env.NEXT_PUBLIC_ENVIRONMENT !== 'live';

export const BASE_URL = process.env.NEXT_PUBLIC_BASE_URL || 'http://localhost:3000';
export const SITE_NAME = 'VALD Health';
export const SITE_IDENTIFIER = 'vh';

export const PROXY_ALLOWED_REQUEST_HOSTS = [
  'localhost',
  'localhost:3000',
  'valdhealth.com',
  'www.valdhealth.com',
  'vald-health-dev.netlify.app',
  'vald-health-int.netlify.app',
] as const;

/** Netlify deploy previews: `{deploy-id}--{site}.netlify.app` (id changes per deploy). */
export const PROXY_ALLOWED_REQUEST_HOST_SUFFIXES = [
  '--vald-health-dev.netlify.app',
  '--vald-health-int.netlify.app',
] as const;

export const MAX_BLOG_ENTRIES_PER_PAGE = 24 as const;

export const ALGOLIA_APP_ID = process.env.NEXT_PUBLIC_ALGOLIA_APP_ID as string;
export const ALGOLIA_API_SEARCH_KEY = process.env.NEXT_PUBLIC_ALGOLIA_API_SEARCH_KEY as string;

export const HUBSPOT_PORTAL_ID = process.env.NEXT_PUBLIC_HUBSPOT_PORTAL_ID;
export const HUBSPOT_POPUP_FORM_ID = process.env.NEXT_PUBLIC_HUBSPOT_POPUP_FORM_ID;

export const DEFAULT_LOCALE = 'en';

export const PAGE_LOCALES = [
  'en', // English
  'fr', // French
  'en-ca', // English/Canada
  'es', // Spanish
];

export const POST_LOCALES = [
  'en', // English
  'en-ca', // English/Canada
  'fr', // French
  'es', // Spanish
  // 'it', // Italian
  'ja', // Japanese
  // 'de', // German
  // 'pt', // Portuguese
  'zh-cn', // Simplified Chinese
  'ko', // South Korean
];

export const IGNORED_PATHS = [
  '/news',
  '/en/news/page/2',
  '/news',
  '/en/news',
  '/fr/news',
  '/es/news',
  '/ko/news',
  '/ja/news',
  '/cn/news',
];

export const ALLOWED_HOSTS = [
  'https://valdhealth.com',
  'http://localhost:3000',
  'https://vald-health-dev.netlify.app',
  'https://vald-health-int.netlify.app',
];
